export enum Endpoint {
	// Auth
	LOGIN = "/auth/login",
	GOOGLE_LOGIN = "/event/auth-code",
	REGISTER = "/auth/register",
	FORGOT_PASSWORD = "/auth/password-recovery",

	// User
	USER = "/user",
	USER_SEARCH = "/user/search",
	USER_ADMIN = "/user/admin",
	USER_ADMIN_PROFILE_PICTURE_PRESIGN = "/user/:userId/uploadPictureUrl",
	USER_IMPORT_FILE = "/importer/users",

	// Sellers
	SELLERS = "/seller/admin",
	SELLER_CREATE = "/seller/admin",
	SELLER_UPDATE = "/seller/admin/{sellerId}",
	SELLER_UPDATE_LOGO = "/seller/{sellerId}/pictures",
	SELLERS_AUTOCOMPLETE = "user/autocomplete",
	SELLERS_DOWNLOAD = "/seller/admin/download",

	// Services
	SELLER_SERVICES = "/service/admin",
	SELLER_SERVICES_CREATE = "/service/admin",
	SELLER_SERVICES_UPLOAD_IMAGE = "service/image/upload",
	SELLER_SERVICES_UPDATE = "/service/admin",
	SELLER_SERVICES_SEARCH = "/service/admin",
	SELLER_SERVICES_EXCEL = "/service/admin/download",
	// Tournaments
	TOURNAMENT_MEMBERS = "/service/:serviceId/tournament-members",
	TOURNAMENT_MEMBERS_DOWNLOAD = "/service/:serviceId/tournament-members/download",
	TOURNAMENT_EXPORT = "/service/:serviceId/tournament/export",

	// Service Sessions
	SERVICE_SESSION_UPDATE = "/service/session/admin",
	SERVICE_SESSION_CREATE = "/service/session/admin",

	// Service Reviews
	SERVICE_REVIEWS = "/service/:serviceId/reviews",
	SERVICE_REVIEW = "/service/review/:id",
	SERVICE_REVIEW_CREATE = "/service/review",

	// Vouchers
	VOUCHER_DETAIL = "/voucher/{voucherId}",
	VOUCHER = "/voucher",
	VOUCHER_UPLOAD_IMAGE = "/voucher/file/upload",
	VOUCHER_UPDATE = "/voucher/{voucherId}",
	VOUCHER_DELETE = "/voucher/delete",

	// Categories
	CATEGORIES = "/category",
	CATEGORIES_LIST = "/category/admin",
	CATEGORIES_UPDATE = "/category/:categoryId",
	CATEGORIES_DELETE = "/category/:categoryId",
	CATEGORIES_DETAIL = "/category/admin",
	CATEGORIES_ICONS = "/category/icon",

	//Microsites
	MICROSITE_ADMIN = "/microsite/admin",
	MICROSITE_SETTINGS = "/microsite/:micrositeId/settings",
	MICROSITES_ALL = "/microsite/admin/all",
	MICROSITE_UPLOAD_IMAGE = "/microsite/admin/:micrositeId/image/:imageType",
	MICROSITES_DETAIL = "/microsites/find",
	MICROSITE_CREATE = "/microsites/create",
	MICROSITE_UPDATE = "/microsites/update",
	MICROSITE_DELETE = "/microsites/delete",
	MICROSITE_DETAIL_UPLOAD_IMAGE = "/microsites/detail/upload",
	MICROSITE_ALL_LANDING_REVIEWS = "/microsite/admin/landing-reviews",
	MICROSITE_LANDING_REVIEWS_BY_SLUG = "/microsite/:slug/landing-reviews",

	MARKETPLACE_LANDING_REVIEWS = "/microsite/admin/marketplace/:marketplace/landing-reviews",
	//Tips
	TIPS = "/tip/tips",
	TIP = "/tip",

	//Transactions
	TRANSACTION_UPLOAD_FILE = "/importer/transactions",
	TRANSACTIONS = "/service/request",
	TRANSACTIONS_DOWNLOAD = "/service/request/download",

	//Gift Cards
	GIFT_CARDS = "/gift-card/admin/movement/list",

	//Marketplaces
	MARKETPLACE = "/marketplaces/:marketplaceCode",

	//Banners
	GET_ALL_BANNERS = "/home/admin/banners/:key",
	CREATE_BANNER = "/home/banner",
	UPDATE_BANNER = "/home/banner/:bannerId",
	DELETE_BANNER = "/home/banner/:bannerId",

	//Reports
	ADMIN_REPORT = "/report/admin",

	//Billing
	GET_INVOICES = "/billing/invoices",
	EXPORT = "/billing/export",
	EXPORT_PAYMENTS = "/billing/export/payments",
	EXPORT_INVOICE_TRANSACTIONS = "/billing/export/transactions",
	UPDATE_STATUS = "/billing/invoices/status",
	UPDATE_EMISSION_DATE = "/billing/invoices/emissionDate",
	UPDATE_INVOICE = "/billing/invoices",
	UPDATE_TRANSACTION_DATE = "/billing/invoices/transactions/createdDate",
	//B2B
	B2B_CONTENT = "/b2b",

	// Surveys
	SURVEYS = "/survey",
	SURVEY_SECTIONS = "/survey/sections",
	SURVEYS_EXPORT = "/survey/:id/export",
	SURVEYS_EXPORT_OPTIONS = "/survey/:id/export/options",

	// Notifications
	NOTIFICATIONS_ADMIN_SEND_USER = "/notifications/admin/send-user",
	NOTIFICATIONS_ADMIN_SEND_USERS = "/notifications/admin/send-users"
}
